<template>
  <div class="home">
    <van-nav-bar title="牧场生物安全评测结果" v-if="isWx==1" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
    <van-nav-bar title="牧场生物安全评测结果" v-else fixed></van-nav-bar>
    <div class="navheight"></div>
    <div class="">
      <div class="branch2" :class="grade < 88 ? 'branch1':'branch'">
        <p class="grade">
          <span class="bra">{{grade}}</span>
          <span class="bra1">分</span>
        </p>
        <p class="grade1">{{risk_level}}</p>
        <p class="grade2">{{suggestion}}</p>
      </div>
      <van-collapse v-model="activeNames" accordion @change="collapse">
        <van-collapse-item title="解决方案" name="1">
          <div class="qus_info" v-for="(item,i) in answer" :key="i">
            <p class="qus_tit">{{item.number}}.{{item.question}}</p>
            <p class="qus_cen">【措施】：{{item.answer}}</p>
          </div>
        </van-collapse-item>
        <van-collapse-item title="采样方案" name="2">
          <p class="qus_tit">1.监测频次:{{detections_num}}</p>
          <p class="qus_tit">2.采样要求:{{sampling_demand}}</p>
          <p class="qus_tit">3.备注:同一采样对象在不同采样点采样时与上一采样点采样位置不要重合</p>
          <p class="qus_tit">4.采样点:{{sampling_point}}  </p>
          <table class="tab_a tab_d">
            <tr>
              <th style="width:80px;">采样区域</th>
              <th style="width:150px;">采样要求</th>
              <th>检测数量</th>
            </tr>
            <tr>
              <td>场区外2-3公里（洗-消点） </td>
              <td style="text-align: left!important;">道路6合1；入场车辆（消毒前）11合1；司机衣物11合1；入场人员衣物11合1；物品外包装6合1</td>
              <td>5个</td>
            </tr>
            <tr>
              <td>场区外1公里 </td>
              <td style="text-align: left!important;">道路6合1；入场车辆（消毒前）11合1；司机衣物11合1；入场人员衣物11合1；物品外包装6合1</td>
              <td>5个</td>
            </tr>
            <tr>
              <td>场区外0-50米 </td>
              <td style="text-align: left!important;">道路6合1；入场车辆（消毒前）11合1；司机衣物11合1；入场人员衣物11合1；物品外包装6合1；饲料1；门卫室7合1；蜱10合1；蚊20合1；蝇20合1</td>
              <td>10个</td>
            </tr>
            <tr>
              <td>场区内</td>
              <td style="text-align: left!important;">入场车辆（消毒前）11合1；通道（赶猪）6合1；员工进入生产区通道6合1；工具（保定器2合1，铁锹2合1，赶猪板2合1等）；售猪区/售猪中转站14合1；场区人员衣物11合1；蜱10合1；蚊20合1；蝇20合1</td>
              <td>11个</td>
            </tr>
            <tr>
              <td>猪群</td>
              <td style="text-align: left!important;">猪只唾液3合1</td>
              <td>10个以上</td>
            </tr>
          </table>
          <p class="qus_cen">采样注意事项</p>
          <p class="qus_tit">1.道路/通道采样：路面表层（土壤）取6个；</p>
          <p class="qus_tit">2.车辆：分别在后车轮里侧2个；每层厢板5个；前脸1个；后门1个；驾驶室脚踏板1个，方向盘1个；</p>
          <p class="qus_tit">3.人员衣物（司机、入场人员）：上衣衣袖2个，背部1个，裤子膝盖2个；鞋子前帮围2个，中底2个，帮面2个；</p>
          <p class="qus_tit">4.饲料，包括原料：采1个</p>
          <p class="qus_tit">5.物品外包装：分散采6个；</p>
          <p class="qus_tit">6.工具：铁锹和扫帚两端各采2个，保定器接触动物端取2个，赶猪板两侧各取2个；</p>
          <p class="qus_tit">7.门卫室：地面均匀分散（4个角，中心）采5个点；内、外门把手各1；</p>
          <p class="qus_tit">8.蜱、蚊蝇：蜱10只一个样；蚊20只一个样；蝇20只一个样；</p>
          <p class="qus_tit">9.围墙：从车辆出入频繁的大门口附近的围墙上随机选择5个点；</p>
          <p class="qus_tit">10.售猪区/售猪中转站：地磅5个点（地磅栏条2个，地面3个）；地磅下地面4个点；附近地面上选5个点；</p>
          <p class="qus_tit">11.猪群：</p>
          <p class="qus_tit">1）母猪样（母猪场）：500头以上30份，100-500头19份，100头以下10份；</p>
          <p class="qus_tit">2）专业育肥场：500头以上30份，不足500头19份。</p>
        </van-collapse-item>
        <van-collapse-item title="检测方案" name="3">
          <div class="qus_info">
            <p class="qus_tit">本方案中采用灵敏度高的荧光PCR的方法，检测项目是非洲猪瘟病毒（详见表4）。检测结果为阳性则说明某区域已经被污染。</p>
            <table class="tab_a">
              <tr>
                <th>检测项目</th>
                <th>检测方法</th>
                <th>结果判断</th>
              </tr>
              <tr>
                <td>ASFV</td>
                <td>荧光PCR</td>
                <td>+/-</td>
              </tr>
            </table>
          </div>
        </van-collapse-item>
        <van-collapse-item title="收费标准及检测频次" name="4">
          <p class="qus_tit">单次费用{{fee}}元，包年{{fee_num_year}}元（{{fee_year}}）。</p>
        </van-collapse-item>
        <van-collapse-item title="送样要求" name="5">
          <p class="qus_tit">样本密封，分类标记清晰后放置在保温箱或泡沫箱内（箱体内放置2个冰袋）立即送往实验室，无法当天送达的，需4℃或-20℃保存，并尽快送出。</p>
        </van-collapse-item>
      </van-collapse>
      <div class="btn_bottom">
        <van-button round plain type="warning" @click="retest">重新检测</van-button>
        <van-button round type="warning" v-if="isWx==1" @click="laboratorys">联系实验室</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { mapGetters } from 'vuex'
import { farmanswer } from '@/api/resetApi.js'

export default {
  name: 'pastureresult',
  data(){
    return{
      activeNames: '',
      grade: '',
      risk_level: '',
      suggestion: '',
      fee: '',
      fee_num_year: '',
      fee_year: '',
      detections_num: '',
      sampling_demand: '',
      sampling_point: '',
      answer: [],
      goodsList: [],
      child_id: '',
      user_id: '',
      isWx: 1,
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      },
    }
  },
  computed: {
    ...mapGetters([
      'pasturelist',
      'pasturedata'
    ]),
  },
  created(){
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
    this.farmanswer()
  },
  methods: {
    async farmanswer() {
      let qs = require('qs');
      let data = qs.stringify(JSON.parse(this.pasturelist))
      const res = await farmanswer(data)
      try {
        if (res.data.code === 1) {
          this.grade = res.data.data.grade
          this.risk_level = res.data.data.risk_level
          this.suggestion = res.data.data.suggestion
          this.fee = res.data.data.detections_fee
          this.fee_num_year = res.data.data.detections_fee_num_year
          this.fee_year = res.data.data.detections_fee_year
          this.answer = res.data.data.answer
          this.detections_num = res.data.data.detections_num
          this.sampling_demand = res.data.data.sampling_demand
          this.sampling_point = res.data.data.sampling_point
          // this.goodsList = res.data.data.baseInfo.goodsList
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    retest() {
      this.$store.state.report.pasturedata = [];
      this.$router.back(-1)
    },
    sublaboratorys() {
      const ua = window.navigator.userAgent.toLowerCase();
      if(ua.indexOf('micromessenger') == -1) {
        this.laboratorys()
      }else{
        wx.miniProgram.navigateTo({url: '../../index/testlist/testlist'})
      }
    },
    laboratorys() {
      if (this.browser.android) {
        ZKAPP.laboratory();
      }else {
        window.webkit.messageHandlers.laboratory.postMessage({name: 'zhangyutang', age: 12});
      }
    },
    collapse(val) {
      this.activeNames = val
    },
    onClickLeft() {
      this.$router.back(-1)
    },
  },
}
</script>

<style lang="scss">
.van-cell__title {
  text-align: left;
}
.van-button--normal {
  width: 40%;
  margin: 10px;
}
.navheight {
  height: 46px;
}
.branch{
  width: 100%;
  height: 230px;
  background: url(../../assets/subjectimg/g1.png) top center no-repeat;
  background-size: 100% 100%; 
  text-align: center;
  margin:0rem auto 20px;
  color:#fff;
}
.branch1{
  width: 100%;
  height: 230px;
  background: url(../../assets/subjectimg/d1.png) top center no-repeat;
  background-size: 100% 100%; 
  text-align: center;
  margin:0rem auto 20px;
  color:#fff;
}
.branch2{
  width: 100%;
  height: 230px;
  text-align: center;
  font-size: 16px;
  margin: 0 auto 20px;
  color:#fff;
  .grade{
    padding-top: 20px;
    .bra{
      font-size: 70px;
    }
    .bra1{
      font-size: 20px;
    }
  }
  .grade1{
    color:#fff;
    font-size: 20px;
    margin-top: 20px;
  }
  .grade2{
    color:#fff;
    margin-top: 40px;
  }
}
.btn_bottom {
  font-size: 0;
  margin-top: 20px; 
  padding-bottom: 20px; 
  overflow: hidden;
}
.qus_tit{
  text-align: left;
  font-size: 14px;
  color: #000;
}
.qus_cen {
  text-align: left;
  font-size: 14px;
  color: #004EA2;
}
.tab_a{
  margin:10px 0;
  width:100%;
  color:#333333;
  border-width: 1px;
  border-color: #CCCCCC;
  border-collapse: collapse;
}
.tab_a tr,th,td{
  border: 1px solid #CCCCCC;
  text-align: center;
  font-size: 12px;
  height: 20px;
  padding: 10px;
}
</style>
